import { log } from '../appMonitoringSuite';

export type FetchAPIOptions = RequestInit & {
  timeout?: number; // Optional timeout for requests
};

export const fetchAPI = async (
  url: string,
  options: FetchAPIOptions = {},
  maxRetries = 3
): Promise<any> => {
  const { timeout = 15000, ...fetchOptions } = options;
  const controller = new AbortController();
  const signal = controller.signal;

  const timer = setTimeout(() => controller.abort(), timeout); // Abort request after timeout

  try {
    const response = await fetch(url, {
      ...fetchOptions,
      headers: {
        ...(fetchOptions.headers ?? {}),
        'x-client-platform': 'platform_html',
      },
      signal,
    });

    if (!response.ok) {
      throw new Error(response.status.toString());
    }
    return response;
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      if (maxRetries > 0) {
        log(
          'Fetch API - timed out API URL:' + url + 'Retry Count - ' + maxRetries,
          'error'
        );
        return fetchAPI(url, { ...fetchOptions, timeout }, maxRetries - 1);
      }

      log('Fetch API - Client Aborted due to timeout. API URL:' + url, 'error');
      throw error;
    }
    throw error; // Other errors such as network issues
  } finally {
    clearTimeout(timer); // Clear timeout once request completes or aborts
  }
};
